import { FC, useEffect } from "react";
import { observer } from "mobx-react-lite";
import { initializeChat } from "../external/Five9Chat";
import type { InitializeChatParams } from "../external/Five9Chat";

export const App: FC = observer(function App() {
  useEffect(() => {
    const params: InitializeChatParams = {
      locale: "es-US"
    };
    initializeChat(params);
  }, []);

  return (
    <>
      Five9Chat should be shown at the bottom of this page ...
    </>
  );
});
